import { Box } from "grommet";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import OrganizationInviteView from "./OrganizationInviteView";
import OrganizationInviteEdit from "./OrganizationInviteEdit";

const RegistrationHome = () => {
    return (
        <Box>
            <Routes>
                <Route path="/invites/:id" element={<OrganizationInviteView />}></Route>
                <Route path="/invites/:id/edit" element={<OrganizationInviteEdit />}></Route>
            </Routes>
        </Box>
    );
};

export default RegistrationHome;
